

// Router
// import '~routes/router';

// CORE Utilities
import '~utilities/get-service-worker';
import '~utilities/keyboard-focus';
import '~utilities/detect-touch';
import '~utilities/detect-breakpoints';
import 'utilities/detect-ie';
import InitializeScript from '~utilities/initialize-script';

// CORE Development

// CORE Components
import Image from '~components/image/js';

import FormExtend from 'components/form';
import Campagne from 'components/campagne';

import ScrollToLink from '~utilities/scroll-to-link';
import AsyncLoadExtend from 'utilities/async-load';
import WindowApp from 'utilities/WindowApp';
import Expandable from 'utilities/Expandable';
import InAnimation from 'utilities/InAnimation';
import Encyclopedia from 'utilities/encyclopedia';
import Scroll from 'utilities/scroll';
import MovingCard from 'utilities/moving-card';

window.app = new WindowApp();

const dynamicCustomElement = async (tagName, path) => {
	// Check if tagName already defined
	if(customElements.get(tagName)) return;
	
	// Check if tagName exist in HTML
	const elements = [...document.getElementsByTagName(tagName)];
	if(!elements.length) return;
	
	
	// Import customElement
	await import(`../${path}.js`).then(({ default: ElementClass}) => {
		if(!customElements.get(tagName)) customElements.define(tagName, ElementClass);
	})
}

onLoad();
customElements.define('c-expandable', Expandable);

export function onLoad(content = document) {
	new Encyclopedia();
	InitializeScript.async('js-form', FormExtend, content);
	InitializeScript.async('js-in-animation', InAnimation, content);
	InitializeScript.async('js-async-load', AsyncLoadExtend, content);
	InitializeScript.async('js-image', Image, content);
	InitializeScript.async('js-scroll-to-link', ScrollToLink, content);
	InitializeScript.async('js-scroll', Scroll, content);
	InitializeScript.async('js-campagne', Campagne, content);
	InitializeScript.async('js-moving-card', MovingCard, content);
	
	// Custom Elements
	dynamicCustomElement('c-modal', 'components/modal/js/index');
	dynamicCustomElement('c-devbar', 'development/devbar/js/index');
	dynamicCustomElement('d-styleguide', 'development/styleguide/js/index');
	dynamicCustomElement('c-loader', 'js/components/loader');
	dynamicCustomElement('c-tooltip', 'components/tooltip/js/index');
	dynamicCustomElement('c-bypass', 'components/bypass-navigation/js/index');
	dynamicCustomElement('c-tab', 'components/tab/js/index');
	dynamicCustomElement('c-accordion', 'components/accordion/js/index');
	dynamicCustomElement('c-tabcordion', 'components/tabcordion/js/index');
	dynamicCustomElement('c-filter', 'components/filter/js/index');
	dynamicCustomElement('c-video', 'js/utilities/VideoContainer');
	dynamicCustomElement('c-carousel', 'components/carousel/js/index');
	dynamicCustomElement('c-scroll-icon', 'js/components/scroll-icon');
	dynamicCustomElement('c-entropy-calculator', 'js/components/entropy-calculator');
	dynamicCustomElement('c-entropy-dashboard', 'js/components/entropy-dashboard');
	dynamicCustomElement('c-entropy-dashboard', 'js/components/dial');
	dynamicCustomElement('c-custom-player', 'components/custom-player/js/index');
	dynamicCustomElement('c-contrast-button', 'components/contrast-button/js/index');
	dynamicCustomElement('c-expand', 'js/components/expand');
	dynamicCustomElement('c-waves', 'js/components/waves');
	dynamicCustomElement('c-image-comparision', 'js/components/image-comparision');
	dynamicCustomElement('c-advanced-filter', 'js/components/advanced-filter');
	dynamicCustomElement('c-breadcrumb', 'components/breadcrumb/js/index');
	dynamicCustomElement('c-scroll-animation', 'js/components/scroll-animation');
	dynamicCustomElement('c-menu', 'js/components/Menu');
	dynamicCustomElement('c-nav', 'js/components/nav');
	dynamicCustomElement('c-background-parallax', 'js/components/background-parallax');
	dynamicCustomElement('c-content', 'js/components/Content');
	dynamicCustomElement('c-indicator', 'js/components/indicator');
	dynamicCustomElement('c-interactive-map', 'js/components/interactive-map');
	dynamicCustomElement('c-contact-person', 'js/components/contact-person');
	dynamicCustomElement('c-link-card', 'js/components/link-card');
	dynamicCustomElement('c-link-small-card', 'js/components/link-small-card');
	dynamicCustomElement('c-case-data', 'js/components/case-data');
	dynamicCustomElement('c-background-video', 'js/components/background-video');
	dynamicCustomElement('c-language-switch', 'js/components/language-switch');
	dynamicCustomElement('u-video-manager', 'js/utilities/video-manager');
	dynamicCustomElement('u-leadinfo', 'js/utilities/leadinfo');
	dynamicCustomElement('c-listing-card', 'js/components/listing-card');
	dynamicCustomElement('c-love-brand-graphic', 'js/components/love-brand-graphic');
}

//# sourceMappingURL=app.js.map